import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import {
  fetchGetNewbuildingDeveloperValuation,
  TGetNewbuildingDeveloperValuationRequest,
  TGetNewbuildingDeveloperValuationResponse,
} from '../../repositories/newbuilding-estimate/v1/get-newbuilding-developer-valuation';
import { IGetNewbuildingDeveloperValuationResponse } from '../../repositories/newbuilding-estimate/entities/newbuilding_developer_valuation/GetNewbuildingDeveloperValuationResponse';
import { IApplicationContext } from '../../types/applicationContext';

interface IParams extends TGetNewbuildingDeveloperValuationRequest {
  context: IApplicationContext;
}

export async function fetchRealtyValuation({
  context,
  developerId,
  newbuildingClass,
  period,
  regionId,
  roomCount,
}: IParams): Promise<IGetNewbuildingDeveloperValuationResponse | null> {
  try {
    const res: TGetNewbuildingDeveloperValuationResponse = await fetchGetNewbuildingDeveloperValuation({
      httpApi: context.httpApi,
      parameters: { developerId, newbuildingClass, period, regionId, roomCount },
    });

    if (res.statusCode !== 200) {
      throw new HttpBadStatusCodeError({
        statusCode: res.statusCode,
        domain: 'fetchRealtyValuation.ts',
        message: res.response.message || '',
      });
    }

    return res.response;
  } catch (e) {
    if (!(e instanceof HttpBadStatusCodeError)) {
      context.logger.error(e);
    } else {
      context.logger.debug(e.message, { details: e.printDetails() });
    }

    return null;
  }
}
